export default __webpack_public_path__ + "static/media/active-user-icon.698c0cc5.svg";